const degreeOptions = [
  { value: "MD", label: "M.D. Doctor of Medicine" },
  { value: "BEng", label: "B.Eng. Bachelor of Engineering" },
  { value: "BS", label: "B.S. Bachelor of Science" },
  { value: "BA", label: "B.A. Bachelor of Arts" },
  { value: "BBA", label: "B.B.A. Bachelor of Business Administration" },
  { value: "BEd", label: "B.Ed. Bachelor of Education" },
  { value: "BFA", label: "B.F.A. Bachelor of Fine Arts" },
  { value: "BM", label: "B.M. Bachelor of Medicine" },
  { value: "BMus", label: "B.Mus. Bachelor of Music" },
  { value: "LLB", label: "LL.B. Bachelor of Law" },
  { value: "BPhi", label: "B.Phil. Bachelor of Philosophy" },
  { value: "BSEE", label: "B.S.E.E. Bachelor of Science/Electrical Engineering" },
  { value: "BSME", label: "B.S.M.E. Bachelor of Mechanical Engineering" },
  { value: "BSN", label: "B.S.N. Bachelor of Nursing" },
  { value: "AB", label: "A.B. Arts Bachelor" },
  { value: "LLM", label: "LL.M. Master of Law" },
  { value: "MA", label: "M.A. Master of Arts" },
  { value: "MArch", label: "M.Arch. Master of Architecture" },
  { value: "MBA", label: "M.B.A. Master of Business Administration" },
  { value: "MS", label: "M.S. Master of Science" },
  { value: "ME", label: "M.E. Mechanical Engineering" },
  { value: "MEd", label: "M.Ed. Master of Education" },
  { value: "MEng", label: "M.Eng. Master of Engineering" },
  { value: "MM", label: "M.M. Masters of Management" },
  { value: "MMSC", label: "M.M.S.C. Master of Medical Science" },
  { value: "MMus", label: "M.Mus. Master of Music" },
  { value: "MNur", label: "M.Nur. Master of Nursing" },
  { value: "MPP", label: "M.P.P. Master of Public Policy" },
  { value: "MPS", label: "M.P.S. Master of Political Science" },
  { value: "MPhi", label: "M.Phil. Master of Philosophy" },
  { value: "MSCE", label: "M.S.C.E. Master of Science in Civil Engineering" },
  { value: "MSCS", label: "M.S.C.S. Master of Science in Computer" },
  { value: "MSE", label: "M.S.E. Master of Science in Engineering" },
  { value: "MSEE", label: "M.S.E.E. Master of Science in Electrical Engineering" },
  { value: "MSME", label: "M.S.M.E. Master of Science in Mechanical Engineering" },
  { value: "DMD", label: "D.M.D. Doctor of Dental Medicine" },
  { value: "DPM", label: "D.P.M. Doctor of Physical Medicine" },
  { value: "DPhil", label: "D.Phil. Doctor of Philosophy" },
  { value: "DA", label: "D.A. Doctor of Arts" },
  { value: "DEd", label: "D.Ed. Doctor of Education" },
  { value: "DM", label: "D.M. Doctor of Music" },
  { value: "LLD", label: "LL.D. Doctor of Law" },
  { value: "AS", label: "A.S. Associate in Science" },
];

export default degreeOptions;
